<template>
  <div style="margin-top: 25px;">
    <b-carousel
      :ref="slideId"
      :id="slideId"
      v-model="slide"
      :interval="interval"
      :controls="controls"
      :indicators="indicators"
      background="#FFFFFF"
      :img-height="viewHeight"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      :no-touch="true"
    >
      <b-carousel-slide
        v-for="(anAudio, i) in userDataPlaylistFinal"
        :name="anAudio.name"
        :key="i"
      >
        <template #img>
          <audio-row
            :audio="anAudio"
            :assets-url-home="assetsURLHome"
            :settings-show-selected-bys="settings_ShowSelectedBys"
            :settings-cover-display="settings_CoverDisplay"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
    <resource-nav-bar
        v-if="resource && !settings_hideBottomBar"
        :resource="resource"
        @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <items-sidebar
            :items="userDataPlaylistFinal"
            :assets-url-home="assetsURLHome"
            @item-clicked="handlePlayItem"
        />
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import _ from "lodash";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import ItemsSidebar from "@/components/blockResources/_components/itemsSideBar";
import AudioRow from "./audioRow";

import DefaultPlayList from "../../assets/json/defaultPlayList.json";
export default {
  name: "Display_PlayList",
  mixins: [ResourceBlockDisplay],
  components: {
    AudioRow,
    ResourceNavBar,
    ItemsSidebar
  },
  props: {},
  created() {},
  mounted() {
    this.handleAnyPlaylistAdjustments();
    this.playRepeat();
  },
  computed: {
    /* SETTINGS */
    settings_CoverDisplay() {
      return this.settings && this.settings.user
        ? this.settings.user.coverDisplay
        : "full";
    },
    settings_isRepeat() {
      return this.settings && this.settings.user
          ? this.settings.user._isRepeat
          : "full";
    },
    settings_isShuffle() {
      return this.settings && this.settings.user
          ? this.settings.user._isShuffle
          : "full";
    },
    settings_ShowSelectedBys() {
      return this.settings && this.settings.user
          ? this.settings.user._showSelectedBys
          : "full";
    },
    /* DATA */
    userDataPlaylist() {
      return this.userData && this.userData.playlist
        ? this.userData.playlist
        : DefaultPlayList;
    }
  },
  methods: {
    handleAnyPlaylistAdjustments(){
      this.userDataPlaylistFinal =  this.settings_isShuffle ?
           _.shuffle (this.userDataPlaylist):
          this.userDataPlaylist;
    },
    playRepeat() {
      if (this.playInd < this.userDataPlaylistFinal.length) {
        //Just in case a new one is added or deleted during play
        const audioURL = `${this.assetsURLHome}${
          this.userDataPlaylistFinal[this.playInd].audioURL
        }`;
        this.player = new Audio(audioURL);

        //let that = this; // Check that there are no issues with this
        this.player.addEventListener("ended", (p)=> {
          this.player.currentTimer = 0;

          if (this.playInd === this.userDataPlaylistFinal.length-1){
            //Reset to 0 and play again if in settings
            this.playInd = 0;
            if (this.settings_isRepeat){
              this.handleAnyPlaylistAdjustments();
              this.playRepeat();
            }
          }else{
            this.playInd++; //If shuffle- then randomize
            this.playRepeat();
          }
          this.handleGoToSlideAudioWith(this.playInd);
        });
        //this.audioDuration = this.getDuration(this.player.duration);
        if (this.player) {
          this.player.play();
        }
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleGoToSlideAudioWith(audioInd) {
      this.$refs[this.slideId].setSlide(audioInd);
    },
    handleShowPlayList() {
      this.handleOpenSideBar();
    },
    handlePlayItem(item) {
      let currentIndexOfItem = Array.isArray(this.userDataPlaylistFinal)
        ? this.userDataPlaylistFinal.findIndex(x => x.uid === item.uid)
        : 0;
      this.playInd = currentIndexOfItem;
      this.player.pause();
      this.handleGoToSlideAudioWith(currentIndexOfItem);
      this.handleCloseSideBar();
      this.playRepeat();

      this.playInd = ind;
      this.player.pause();
      this.handleGoToSlideAudioWith(this.playInd);
      this.handleCloseSideBar();
      this.playRepeat();
    }
  },
  data() {
    return {
      DefaultPlayList,
      userDataPlaylistFinal:[],
      assetsURLHome: "/assets/apps/playlist/",
      audioDuration: null,
      sidebarId: "playlist-sidebar",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      interval: 0,
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
